/**
 * TODO Document
 */
export const appendOptionsToPayload = (payload, optionSelections) => {
    const { item } = payload;

    const options = Array.from(optionSelections, ([id, value]) => ({
        option_id: id,
        option_value: value
    }));

    const selectedVariant = null;

    if (!selectedVariant) return payload;

    Object.assign(payload, {
        options,
        parentSku: item.sku,
        item: Object.assign({}, selectedVariant.product)
    });

    return payload;
};
